mutation ReadAllNotificationsMutation {
  readAllNotifications
}
